import script from "./NotePopupComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotePopupComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotePopupComponent.vue?vue&type=style&index=0&id=b8331844&lang=scss"

const __exports__ = script;

export default __exports__